<template>
  <v-card>
    <v-card-title>
      {{ $t("auditor.step.success.title") }}
    </v-card-title>

    <v-card-text>
      {{ $t("auditor.step.success.text") }}
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="primary"
        :to="{
          name: 'auditAuditPeriod',
          params: { id: fund.auditPeriod.id },
        }"
      >
        {{ $t("auditor.step.success.cta") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    fund: {
      type: Object,
      required: true,
    },
  },
};
</script>
